import {useContext} from "react";
import {SpecialistFormContext} from "../contexts/specialist-form-context";

export const useSpecialistForm = () => {
    const context = useContext(SpecialistFormContext);
    if (!context) {
        throw new Error('useSpecialistForm must be used within SpecialistFormProvider');
    }
    return context;
};
